export default {
  data: () => ({
    translations: {
      newTransaction: {
        el: 'Νέα Συναλλαγή',
        en: 'New Transaction',
        it: 'Nuova Transazione',
      },
      info: {
        el: 'Στείλε πόντους σε παλιούς και νέους χρήστες χρησιμοποιώντας τον αριθμό του τηλεφώνου τους ή τον αριθμό της κάρτας επιβράβευσής τους',
        en: `
                    Send points manually to old or new users based on their mobile
                    phone number or their loyalty card number
                `,
        it: 'Inviare manualmente punti a vecchi o nuovi utenti in base al loro numero di cellulare o al numero della loro carta fedeltà',
      },
      selectUser: {
        el: 'Επίλεξε Χρήστη',
        en: 'Select User:',
        it: "Scegliere l'utente",
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      user: {
        el: 'Χρήστης (αριθμός τηλεφώνου ή αριθμός κάρτας επιβράβευσης)',
        en: 'User (mobile or loyalty card number)',
        it: 'Utende (numero di cellulare o carta fedelta)',
      },
      userVoucher: {
        el: '',
        en: 'User has voucher code',
        it: '',
      },
      receiptNumber: {
        el: 'Αριθμός Απόδειξης',
        en: 'Receipt Number',
        it: 'Numero di ricevuta',
      },
      receiptIdentifier: {
        el: 'Αναγνωριστικό Απόδειξης',
        en: 'Receipt Identifier',
        it: 'Identificatore della ricevuta',
      },
      voucherCode: {
        el: 'Κωδικός Κουπονιού',
        en: 'Voucher code',
        it: 'Codice del buono',
      },
      productAmount: {
        el: 'Ποσό',
        en: 'Amount',
        it: 'Importo',
      },
      createOrder: {
        el: 'ΠΡΟΣΘΗΚΗ',
        en: 'CREATE ORDER',
        it: 'CREA ORDINE',
      },
      alertText: {
        el: 'Εισάγετε το κινητό ή την κάρτα πιστότητας εδώ.',
        en: 'Enter phone or loyalty card number below.',
        it: 'Inserisci qui il tuo cellulare o la tua carta fedeltà',
      },
      tip: {
        el: 'TIP',
        en: 'TIP',
        it: 'TIP',
      },
      currentTier: {
        el: 'Eπίπεδο:',
        en: 'Current Tier:',
        it: 'Livello attuale:',
      },
      pointsForTheNextTier: {
        el: 'Απομένουν για το επόμενο επίπεδο:',
        en: 'Points for the next tier:',
        it: 'Punti per il livello successivo:',
      },
      cashbackForTheNextTier: {
        el: 'Απομένουν για το επόμενο επίπεδο:',
        en: 'Cashback for the next tier:',
        it: 'Cashback per il livello successivo:',
      },
      amount: {
        el: 'Συνολικό ποσό',
        en: 'Total amount',
        it: 'Importo totale',
      },
      forTheNextTier: {
        el: ' για το επόμενο επίπεδο:',
        en: ' for the next tier:',
        it: ' per il livello successivo:',
      },
      verificationCodeTitle: {
        el: 'Επαλήθευση κινητού τηλεφώνου',
        en: 'Enter the verification code',
        it: 'Inserisci il codice di verifica',
      },
      verificationCodeDescription: {
        el: 'Παρακαλώ συμπληρώστε τον 4-ψήφιο κωδικό, που έχει σταλθεί στο κινητό του χρήστη',
        en: "Please enter the 4-digit verification code sent to user's mobile",
        it: "Inserisci il codice di verifica di 4 cifre inviato al cellulare dell'utente",
      },
      confirmScanMsg: {
        el: 'twra',
        en: 'now',
        it: '!',
      },
      confirmScanTitle: {
        el: 'Scan:',
        en: 'Scan',
        it: 'Scania',
      },
      resetScan: {
        el: 'Αναίρεση Σκαναρίσματος',
        en: 'Reset Scan',
        it: 'Azzeramento della Scansione',
      },
      viewData: {
        el: 'Προβολή/Επεξεργασία Στοιχείων',
        en: 'View/Update Data',
        it: 'Visualizza/Aggiornamento i dati',
      },
      viewMore: {
        el: 'Δείτε περισσότερα',
        en: 'View More',
        it: 'Per saperne di più',
      },
      loyalty: {
        el: 'Πρόγραμμα',
        en: 'Loyalty',
        it: 'Fedeltà',
      },
      current_points: {
        el: 'Τρέχον σύνολο πόντων',
        en: 'Current Points',
        it: 'Totale attuale Punti',
      },
      current_cashback: {
        el: 'Τρέχον σύνολο cashback',
        en: 'Current Cashback',
        it: 'Cashback attuale',
      },
      new_points: {
        el: 'Πόντοι μετά την συναλλαγή',
        en: 'Points after transaction',
        it: 'Punti dopo la transazione',
      },
      new_cashback: {
        el: 'Cashback μετά την συναλλαγή',
        en: 'Cashback after transaction',
        it: 'Cashback dopo la transazione',
      },
      notRegistered: {
        el: 'Mη καταχωρημένη',
        en: 'Not registered',
        it: 'Non registrato',
      },
      mobileRegistrationRequired: {
        el: 'απαιτείται σύνδεση με κινητό',
        en: 'Mobile registration required',
        it: 'È richiesta la registrazione mobile',
      },
      coupons: {
        el: 'Διαθέσιμα Κουπόνια:',
        en: 'Available Coupons:',
        it: 'Coupon Disponibili',
      },
    },
  }),
};
